// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login .oimage[data-v-375a3aae] img{-o-object-fit:cover!important;object-fit:cover!important;position:absolute!important;top:0!important;right:0!important;left:0!important;bottom:0!important;max-width:100%!important;min-width:100%!important;max-height:100%!important;min-height:100%!important}.login[data-v-375a3aae]:after{position:absolute;height:100%;width:100%;top:0;left:0;z-index:0;content:\"\";background:rgba(51,51,51,.1)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
